import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import AuthService from "../../Services/AuthService";
import {
  AdminAuthSliceModelProps,
  AdminAuthUser,
  Categories,
} from "./InitialStatePropsModel";

const expiryKey = `${process.env.REACT_APP_STORAGE_KEY}/accessTokenExpiry`;

const emptyPermissions: Categories = {
  view: false,
  edit: false,
  create: false,
  download: false,
};

const emptyUser: AdminAuthUser = {
  _id: "",
  username: "",
  firstName: "",
  lastName: "",
  image: "",
  password: "",
  email: "",
  mobile: "",
  empId: "",
  roleId: "",
  accessToken: "",
  refreshToken: "",
  roleName: "",
  permissions: {
    categories: emptyPermissions,
    employee: emptyPermissions,
    products: emptyPermissions,
    customers: emptyPermissions,
    supplier: emptyPermissions,
    roles: emptyPermissions,
    settings: emptyPermissions,
    orders: emptyPermissions,
    refunds: emptyPermissions,
    reports: emptyPermissions,
    homeScreen: emptyPermissions,
    taxation: emptyPermissions,
  },
};

const initialState: AdminAuthSliceModelProps = {
  isAuthenticated: false,
  accessToken:
    localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/accessToken`) ??
    "",
  refreshToken:
    localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/refreshToken`) ??
    "",
  accessTokenExpiry: localStorage.getItem(expiryKey)
    ? Number(localStorage.getItem(expiryKey))
    : 0,
  adminAuthUser: emptyUser,
  error: "",
  isLoading: false,
};

const AuthSlice = createSlice({
  name: "AuthSlice",
  initialState,
  reducers: {
    setAuthUser(
      state: AdminAuthSliceModelProps,
      action: PayloadAction<AdminAuthUser>
    ) {
      state.adminAuthUser = action.payload;
      state.isAuthenticated = !!action.payload?._id;
    },
    logout(state: AdminAuthSliceModelProps) {
      localStorage.clear();
      sessionStorage.clear();
      state.adminAuthUser = emptyUser;
      state.isAuthenticated = false;
      state.accessToken = "";
      state.refreshToken = "";
      state.accessTokenExpiry = 0;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setAccessToken(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      // const time=3600;  // 1 hour from now
      const time = 3480; // 58 minutes = 3480 seconds;
      // const time=30; // 30 seconds from now

      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.accessTokenExpiry = currentTime + time; // 58 minutes from now

      localStorage.setItem(
        `${process.env.REACT_APP_STORAGE_KEY}/accessToken`,
        action.payload.accessToken
      );
      localStorage.setItem(
        `${process.env.REACT_APP_STORAGE_KEY}/refreshToken`,
        action.payload.refreshToken
      );
      localStorage.setItem(
        `${process.env.REACT_APP_STORAGE_KEY}/accessTokenExpiry`,
        (currentTime + time).toString()
      );
    },
  },
});
export const { setAuthUser, logout, setAccessToken } = AuthSlice.actions;
export default AuthSlice;
